import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ga--add-to-cart"
export default class extends Controller {
  static values = {
    requestId: String,
    id: Number,
    name: String,
    price: Number,
    sku: String,
    qty: Number,
  }

  connect() {
    if (typeof window.gtag === "function" && this.hasIdValue && this.hasNameValue && this.hasPriceValue && this.hasSkuValue && this.hasQtyValue) {
      gtag('event', 'add_to_cart', {
        currency: 'USD',
        value: this.qtyValue * this.priceValue,
        items: [
          {
            item_id: this.idValue,
            item_name: this.nameValue,
            item_variant: this.skuValue,
            price: this.priceValue,
            quantity: this.qtyValue
          }
        ]
      });

      gtag('event', 'button_click', {
        button: 'add to cart'
      });

      // event_id belongs in the third argument, not the properties: the pixel
      // reads the dedupe key from the options object only. In properties it is
      // just an inert custom property, and this event never merges with the
      // server-side one from TiktokEventsApiJob.
      ttq.track('AddToCart', {
        content_type: 'product',
        content_ids: [this.idValue],
        currency: 'USD',
        value: this.qtyValue * this.priceValue,
        contents: [
          {
            content_id: this.idValue,
            quantity: this.qtyValue
          }
        ]
      }, {
        event_id: this.requestIdValue,
      });
    }
  }
}
